import React from "react";
import { FormattedMessage } from "react-intl";

interface ContextHolderProps {
    context: string;
    workspaceName: string;
}

export const ContextHolder = (props: ContextHolderProps) => {
    const { context, workspaceName } = props;
    return (
        <>
            <div id={"contextWrapper"}>
                <FormattedMessage id={`workspaceChanges.context.${context}`} />
            </div>
            <div id={"workspaceNameWrapper"}>{workspaceName}</div>
        </>
    );
};
